import { createContext, useContext, useState, useEffect, useCallback } from 'react';

const CompareContext = createContext(null);
const STORAGE_KEY = 'noora_compare';
const MAX_COMPARE = 4;

export const CompareProvider = ({ children }) => {
    const [compareIds, setCompareIds] = useState(() => {
        try {
            const saved = localStorage.getItem(STORAGE_KEY);
            return saved ? JSON.parse(saved) : [];
        } catch { return []; }
    });

    useEffect(() => {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(compareIds));
    }, [compareIds]);

    const toggleCompare = useCallback((productId) => {
        setCompareIds(prev => {
            if (prev.includes(productId)) {
                return prev.filter(id => id !== productId);
            }
            if (prev.length >= MAX_COMPARE) {
                return prev; // Max reached
            }
            return [...prev, productId];
        });
    }, []);

    const isInCompare = useCallback((productId) => compareIds.includes(productId), [compareIds]);

    const removeFromCompare = useCallback((productId) => {
        setCompareIds(prev => prev.filter(id => id !== productId));
    }, []);

    const clearCompare = useCallback(() => {
        setCompareIds([]);
    }, []);

    return (
        <CompareContext.Provider value={{
            compareIds, toggleCompare, isInCompare, removeFromCompare, clearCompare,
            compareCount: compareIds.length, maxCompare: MAX_COMPARE
        }}>
            {children}
        </CompareContext.Provider>
    );
};

const defaultValue = {
    compareIds: [], toggleCompare: () => {}, isInCompare: () => false,
    removeFromCompare: () => {}, clearCompare: () => {},
    compareCount: 0, maxCompare: MAX_COMPARE
};
export const useCompare = () => useContext(CompareContext) || defaultValue;
